import {formatGeoPoint} from "../bl/routeRequestUtils";

/** @param {Object} data
 * @param {City} data.city
 * @param {Region} data.region
 * @param {Country} data.country
 * @param {GeoPoint} data.geoPoint
 * @returns {string}
 */
export const getAddress = ({city, region, country, geoPoint}) => {
  const addressParts = getAddressParts({city, region, country, geoPoint});
  return addressParts.filter(Boolean).join(', ');
};

/** Возвращает две части адреса точки: [0] - основная часть (название НП или координаты); [1] - уточняющая (районы, регион, страна) 
 * @param {Object} data
 * @param {City} data.city
 * @param {Region} data.region
 * @param {Country} data.country
 * @param {GeoPoint} data.geoPoint
 * @returns {string[]}
 */

export const getAddressParts = ({city, region, country, geoPoint}) => {
  const result = [city?.clarifiedName || formatGeoPoint(geoPoint)];
  const clarifyParts = [];
  if((!city || !city.isRegionalCenter) && region) {
    clarifyParts.push(region.clarifiedName);
  }
  if(country) {
    clarifyParts.push(country.name);
  }
  result.push(clarifyParts.length > 0 ? clarifyParts.join(', ') : undefined);
  return result;
};